import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Helper function to send push notifications via Supabase edge function
export async function sendPushNotification(
  title: string,
  message: string,
  userIds?: string[],
  data?: any
) {
  try {
    const { supabase } = await import("@/integrations/supabase/client");
    
    // Extract targetRole from data if present
    const targetRole = data?.targetRole;
    const cleanData = data ? { ...data } : {};
    delete cleanData.targetRole; // Remove targetRole from data object
    
    console.log('🔔 Sending push notifications:', { title, message, userIds, targetRole });
    
    const response = await supabase.functions.invoke('send-push-notification', {
      body: {
        title,
        message,
        userIds,
        targetRole, // Pass targetRole as top-level parameter
        data: {
          ...cleanData,
          timestamp: new Date().toISOString()
        }
      }
    });

    if (response.error) {
      console.error('❌ Push notification error:', response.error);
      return { success: false, error: response.error };
    }

    console.log('✅ Push notification sent successfully:', response.data);
    return { success: true, data: response.data };
  } catch (error) {
    console.error('💥 Failed to send push notification:', error);
    return { success: false, error };
  }
}
